import React, { useState } from 'react';
import styled from 'styled-components';
import { ProgressBar } from 'antd-mobile';
import { PlayOutline, ClockCircleOutline, StarOutline, EyeOutline, HeartOutline, CheckCircleOutline } from 'antd-mobile-icons';
import { useParams, useNavigate } from 'react-router-dom';
import TextLightScroll from '../../components/texts/TextLightScroll';

const PersonalizedRecommendationDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');
  const [isFavorited, setIsFavorited] = useState(false);

  // 模拟个性化推荐详情数据
  const course = {
    title: '基于你的Python基础推荐：数据科学入门',
    description: '根据你的编程背景和学习目标，这门课程将帮助你快速掌握数据分析和机器学习的核心技能。课程采用项目驱动的学习方式，结合实际案例，让你在实践中掌握数据科学的精髓。',
    category: '数据科学',
    difficulty: '中级',
    duration: '6周',
    rating: 4.8,
    students: 1234,
    instructor: {
      name: 'Dr. 李明',
      title: '数据科学专家',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=60&h=60&fit=crop&crop=face',
      experience: '10年+',
      courses: 15,
      students: 50000
    },
    thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=400&fit=crop',
    tags: ['Python', '数据分析', '机器学习', 'Pandas', 'NumPy', 'Matplotlib'],
    progress: 0,
    matchScore: 95,
    price: 299,
    originalPrice: 399,
    reasons: [
      {
        icon: '🎯',
        title: '基于你的Python技能',
        description: '你已经掌握了Python基础，这门课程将在此基础上深入数据科学领域'
      },
      {
        icon: '📈',
        title: '符合你的学习目标',
        description: '根据你的学习档案，数据科学是你感兴趣的发展方向'
      },
      {
        icon: '⏰',
        title: '适合你的时间安排',
        description: '6周的学习周期符合你的可用学习时间'
      },
      {
        icon: '💼',
        title: '职业发展匹配',
        description: '数据科学技能将为你的职业发展带来更多机会'
      }
    ],
    learningPath: [
      {
        week: 1,
        title: 'Python数据处理基础',
        topics: ['NumPy数组操作', 'Pandas数据框架', '数据清洗技巧'],
        duration: '8小时',
        completed: false
      },
      {
        week: 2,
        title: '数据可视化',
        topics: ['Matplotlib绘图', 'Seaborn高级可视化', '交互式图表'],
        duration: '10小时',
        completed: false
      },
      {
        week: 3,
        title: '统计分析基础',
        topics: ['描述性统计', '假设检验', '相关性分析'],
        duration: '12小时',
        completed: false
      },
      {
        week: 4,
        title: '机器学习入门',
        topics: ['监督学习', '无监督学习', '模型评估'],
        duration: '15小时',
        completed: false
      },
      {
        week: 5,
        title: '实战项目一',
        topics: ['销售数据分析', '客户细分', '预测模型'],
        duration: '20小时',
        completed: false
      },
      {
        week: 6,
        title: '实战项目二',
        topics: ['股票价格预测', '模型部署', '项目展示'],
        duration: '18小时',
        completed: false
      }
    ],
    prerequisites: [
      'Python基础语法',
      '基本的数学知识',
      '对数据分析有兴趣'
    ],
    outcomes: [
      '掌握Python数据分析核心库',
      '能够进行数据清洗和预处理',
      '具备数据可视化能力',
      '了解机器学习基本概念',
      '完成2个实战项目'
    ],
    skills: [
      {
        name: 'Python编程',
        current: 70,
        required: 60,
        status: 'good'
      },
      {
        name: '数据分析',
        current: 30,
        required: 50,
        status: 'warning'
      },
      {
        name: '机器学习',
        current: 10,
        required: 40,
        status: 'poor'
      },
      {
        name: '统计学',
        current: 40,
        required: 45,
        status: 'warning'
      }
    ],
    reviews: [
      {
        id: 1,
        user: '张同学',
        avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=40&h=40&fit=crop&crop=face',
        rating: 5,
        date: '2024-01-15',
        content: '课程内容非常实用，老师讲解清晰，项目案例很有代表性。学完后对数据科学有了全面的认识。',
        helpful: 23
      },
      {
        id: 2,
        user: '李同学',
        avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face',
        rating: 4,
        date: '2024-01-10',
        content: '整体不错，但是有些概念讲解可以更深入一些。实战项目很棒，学到了很多实用技能。',
        helpful: 15
      }
    ],
    similarCourses: [
      {
        id: 2,
        title: '机器学习进阶实战',
        thumbnail: 'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?w=300&h=180&fit=crop',
        rating: 4.7,
        students: 856,
        price: 399
      },
      {
        id: 3,
        title: '深度学习入门',
        thumbnail: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=300&h=180&fit=crop',
        rating: 4.6,
        students: 642,
        price: 499
      }
    ]
  };

  const tabs = [
    { key: 'overview', title: '课程概述' },
    { key: 'curriculum', title: '学习路径' },
    { key: 'skills', title: '技能匹配' },
    { key: 'reviews', title: '学员评价' },
    { key: 'similar', title: '相似推荐' }
  ];

  if (!course) {
    return (
      <StyledWrapper>
        <div className="recommendation-detail-container">
          <div className="error-container">
            <h2>推荐课程未找到</h2>
            <button className="back-btn" onClick={() => navigate('/learn/recommendations')}>返回推荐列表</button>
          </div>
        </div>
      </StyledWrapper>
    );
  }

  return (
    <StyledWrapper>
      <div className="recommendation-detail-container">
        <div className="breadcrumb">
          <span onClick={() => navigate('/learn/recommendations')}>个性化推荐</span> / {course.title}
        </div>

        {/* 匹配度徽章 */}
        <div className="match-score-badge">
          <span className="score">{course.matchScore}%</span>
          <span className="label">匹配度</span>
        </div>

        {/* 课程头部信息 */}
        <div className="course-header">
          <div className="course-info">
            <TextLightScroll text={course.title} />
            <p className="description">{course.description}</p>
            
            <div className="course-meta">
              <div className="meta-item">
                <span className="category">{course.category}</span>
              </div>
              <div className="meta-item">
                <span className="difficulty">{course.difficulty}</span>
              </div>
              <div className="meta-item">
                <ClockCircleOutline />
                <span>{course.duration}</span>
              </div>
              <div className="meta-item">
                <StarOutline />
                <span>{course.rating} ({course.students}人学习)</span>
              </div>
            </div>
            
            <div className="course-tags">
              {course.tags.map((tag, index) => (
                <span key={index} className="tag">{tag}</span>
              ))}
            </div>
          </div>
          
          <div className="course-thumbnail">
            <img src={course.thumbnail} alt={course.title} />
          </div>
        </div>

        {/* 推荐理由卡片 */}
        <div className="recommendation-reasons-card">
          <h3>为什么推荐这门课程</h3>
          <div className="reasons-grid">
            {course.reasons.map((reason, index) => (
              <div key={index} className="reason-item">
                <div className="reason-icon">{reason.icon}</div>
                <div className="reason-content">
                  <h4>{reason.title}</h4>
                  <p>{reason.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 购买/学习卡片 */}
        <div className="purchase-card">
          <div className="purchase-info">
            <div className="instructor-section">
              <img src={course.instructor.avatar} alt={course.instructor.name} className="instructor-avatar" />
              <div className="instructor-details">
                <h4>{course.instructor.name}</h4>
                <p>{course.instructor.title}</p>
                <div className="instructor-stats">
                  <span>{course.instructor.experience}经验</span>
                  <span>{course.instructor.courses}门课程</span>
                  <span>{course.instructor.students}+学员</span>
                </div>
              </div>
            </div>
            
            <div className="price-section">
              <div className="prices">
                <span className="current-price">¥{course.price}</span>
                <span className="original-price">¥{course.originalPrice}</span>
                <span className="discount">限时优惠</span>
              </div>
            </div>
          </div>
          
          <div className="action-buttons">
            <button 
              className={`favorite-btn ${isFavorited ? 'favorited' : ''}`}
              onClick={() => setIsFavorited(!isFavorited)}
            >
              <HeartOutline /> {isFavorited ? '已收藏' : '收藏'}
            </button>
            <button className="enroll-btn">
              立即报名
            </button>
          </div>
        </div>

        {/* 标签页内容 */}
        <div className="tabs-container">
          <div className="tabs-header">
            {tabs.map(tab => (
              <button 
                key={tab.key}
                className={`tab-button ${activeTab === tab.key ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.title}
              </button>
            ))}
          </div>
          <div className="tab-content">
            {activeTab === 'overview' && (
              <div className="overview-content">
                <div className="section">
                  <h3>课程前置要求</h3>
                  <ul className="prerequisites-list">
                    {course.prerequisites.map((item, index) => (
                      <li key={index}>
                        <CheckCircleOutline className="check-icon" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <div className="section">
                  <h3>学习收获</h3>
                  <ul className="outcomes-list">
                    {course.outcomes.map((item, index) => (
                      <li key={index}>
                        <CheckCircleOutline className="trophy-icon" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
            
            {activeTab === 'curriculum' && (
              <div className="curriculum-content">
                <div className="curriculum-header">
                  <h3>学习路径</h3>
                  <p>循序渐进的6周学习计划，从基础到实战</p>
                </div>
                
                {course.learningPath.map((week, index) => (
                  <div key={index} className="week-card">
                    <div className="week-header">
                      <div className="week-info">
                        <h4>第{week.week}周：{week.title}</h4>
                        <div className="duration">{week.duration}</div>
                      </div>
                      <span className={`status ${week.completed ? 'completed' : 'pending'}`}>
                        {week.completed ? '已完成' : '待学习'}
                      </span>
                    </div>
                    <div className="topics-list">
                      {week.topics.map((topic, topicIndex) => (
                        <div key={topicIndex} className="topic-item">
                          <span className="topic-bullet">•</span>
                          <span>{topic}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
            
            {activeTab === 'skills' && (
              <div className="skills-content">
                <div className="skills-header">
                  <h3>技能匹配分析</h3>
                  <p>基于你的当前技能水平，分析课程匹配度</p>
                </div>
                
                <div className="skills-list">
                  {course.skills.map((skill, index) => (
                    <div key={index} className="skill-item">
                      <div className="skill-info">
                        <span className="skill-name">{skill.name}</span>
                        <div className="skill-levels">
                          <span>当前: {skill.current}%</span>
                          <span>要求: {skill.required}%</span>
                        </div>
                      </div>
                      <div className="skill-progress">
                        <div className="progress-bg">
                          <div 
                            className="current-progress"
                            style={{ 
                              width: `${skill.current}%`,
                              background: skill.status === 'good' ? '#4CAF50' : 
                                         skill.status === 'warning' ? '#FF9800' : '#F44336'
                            }}
                          />
                          <div 
                            className="required-line"
                            style={{ left: `${skill.required}%` }}
                          />
                        </div>
                      </div>
                      <div className="skill-status">
                        <span className={`status-${skill.status}`}>
                          {skill.status === 'good' ? '符合要求' : 
                           skill.status === 'warning' ? '需要提升' : '差距较大'}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            {activeTab === 'reviews' && (
              <div className="reviews-content">
                <div className="reviews-header">
                  <h3>学员评价</h3>
                  <div className="rating-summary">
                    <span className="rating-score">{course.rating}</span>
                    <div className="rating-stars">
                      {[1, 2, 3, 4, 5].map(star => (
                        <StarOutline 
                          key={star} 
                          className={star <= Math.floor(course.rating) ? 'filled' : ''} 
                        />
                      ))}
                    </div>
                    <span className="rating-count">({course.students}条评价)</span>
                  </div>
                </div>
                
                <div className="reviews-list">
                  {course.reviews.map((review) => (
                    <div key={review.id} className="review-item">
                      <div className="review-header">
                        <img src={review.avatar} alt={review.user} className="reviewer-avatar" />
                        <div className="review-meta">
                          <div className="user-name">{review.user}</div>
                          <div className="review-info">
                            <div className="rating">
                              {[1, 2, 3, 4, 5].map(star => (
                                <StarOutline 
                                  key={star} 
                                  className={star <= review.rating ? 'filled' : ''} 
                                />
                              ))}
                            </div>
                            <span className="date">{review.date}</span>
                          </div>
                        </div>
                      </div>
                      <p className="review-content">{review.content}</p>
                      <div className="review-actions">
                        <span className="helpful">{review.helpful}人觉得有用</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            
            {activeTab === 'similar' && (
              <div className="similar-content">
                <h3>相似推荐</h3>
                <p>基于你的兴趣和学习目标，为你推荐其他相关课程</p>
                
                <div className="similar-courses">
                  {course.similarCourses.map((similarCourse) => (
                    <div 
                      key={similarCourse.id} 
                      className="similar-course-card"
                      onClick={() => navigate(`/learn/recommendations/${similarCourse.id}`)}
                    >
                      <img src={similarCourse.thumbnail} alt={similarCourse.title} />
                      <div className="similar-course-info">
                        <h4>{similarCourse.title}</h4>
                        <div className="similar-course-meta">
                          <div className="rating">
                            <StarOutline className="filled" />
                            <span>{similarCourse.rating}</span>
                          </div>
                          <span className="students">{similarCourse.students}人学习</span>
                          <span className="price">¥{similarCourse.price}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .recommendation-detail-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background: #f5f5f5;
    min-height: 100vh;
    color: #333;
  }

  .error-container {
    text-align: center;
    padding: 100px 20px;
    
    h2 {
      margin-bottom: 20px;
      color: #333;
    }
  }

  .back-btn {
    background: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    
    &:hover {
      background: #0056b3;
    }
  }

  .course-header {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 40px;
    margin-bottom: 30px;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }

  .breadcrumb {
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 10px;
    
    span:first-child {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .match-score-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: linear-gradient(45deg, #4CAF50, #45a049);
    color: white;
    padding: 8px 16px;
    border-radius: 20px;
    font-weight: 600;
    margin-bottom: 15px;
    
    .score {
      font-size: 1.1rem;
    }
    
    .label {
      font-size: 0.9rem;
    }
  }

  .course-info {
    h1 {
      font-size: 2.2rem;
      font-weight: bold;
      margin: 0 0 15px 0;
      color: #333;
      line-height: 1.3;
    }
    
    .description {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #666;
      margin-bottom: 20px;
    }
  }

  .course-meta {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    flex-wrap: wrap;
    
    .meta-item {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 0.95rem;
      color: #666;
      
      .category {
        background: #e3f2fd;
        color: #1976d2;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 0.8rem;
        border: 1px solid #bbdefb;
      }
      
      .difficulty {
        font-weight: 600;
        color: #ff9800;
      }
    }
  }

  .course-tags {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    
    .tag {
      background: #e8f5e8;
      color: #4CAF50;
      padding: 4px 12px;
      border-radius: 16px;
      font-size: 0.8rem;
      border: 1px solid #c8e6c9;
    }
  }

  .course-thumbnail {
    border-radius: 12px;
    overflow: hidden;
    height: fit-content;
    
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .recommendation-reasons-card {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    
    h3 {
      margin: 0 0 20px 0;
      color: #333;
      font-size: 1.3rem;
    }
  }

  .reasons-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
  }

  .reason-item {
    display: flex;
    gap: 15px;
    align-items: flex-start;
    
    .reason-icon {
      font-size: 2rem;
      flex-shrink: 0;
    }
    
    .reason-content {
      h4 {
        margin: 0 0 5px 0;
        color: #007bff;
        font-size: 1rem;
      }
      
      p {
        margin: 0;
        color: #666;
        line-height: 1.4;
        font-size: 0.9rem;
      }
    }
  }

  .purchase-card {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 30px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }

  .purchase-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 20px;
      align-items: flex-start;
    }
  }

  .instructor-section {
    display: flex;
    gap: 15px;
    align-items: center;
    
    .instructor-avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      object-fit: cover;
    }
    
    .instructor-details {
      h4 {
        margin: 0 0 5px 0;
        color: #333;
        font-size: 1.1rem;
      }
      
      p {
        margin: 0 0 8px 0;
        color: #666;
        font-size: 0.9rem;
      }
      
      .instructor-stats {
        display: flex;
        gap: 15px;
        font-size: 0.8rem;
        color: #999;
      }
    }
  }

  .price-section {
    text-align: right;
    
    @media (max-width: 768px) {
      text-align: left;
    }
    
    .prices {
      display: flex;
      align-items: center;
      gap: 10px;
      
      @media (max-width: 768px) {
        justify-content: flex-start;
      }
      
      .current-price {
        font-size: 1.8rem;
        font-weight: bold;
        color: #007bff;
      }
      
      .original-price {
        font-size: 1.1rem;
        text-decoration: line-through;
        color: #999;
      }
      
      .discount {
        background: #ff4757;
        color: white;
        padding: 4px 8px;
        border-radius: 8px;
        font-size: 0.75rem;
      }
    }
  }

  .action-buttons {
    display: flex;
    gap: 15px;
    align-items: center;
    
    .favorite-btn {
      background: white;
      color: #666;
      border: 1px solid #e0e0e0;
      padding: 10px 20px;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 5px;
      
      &.favorited {
        color: #ff4757;
        border-color: #ff4757;
      }
      
      &:hover {
        background: #f8f9fa;
      }
    }
    
    .enroll-btn {
      background: #007bff;
      color: white;
      border: none;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      flex: 1;
      
      &:hover {
        background: #0056b3;
      }
    }
  }

  .tabs-container {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }

  .tabs-header {
    display: flex;
    border-bottom: 1px solid #e0e0e0;
    
    .tab-button {
      flex: 1;
      padding: 16px;
      border: none;
      background: #f8f9fa;
      color: #666;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.2s;
      
      &:hover {
        background: #e9ecef;
      }
      
      &.active {
        background: white;
        color: #007bff;
        border-bottom: 2px solid #007bff;
      }
    }
  }

  .tab-content {
    padding: 24px;
  }

  .overview-content {
    .section {
      margin-bottom: 30px;
      
      h3 {
        font-size: 1.3rem;
        margin-bottom: 15px;
        color: #333;
      }
    }
    
    .prerequisites-list,
    .outcomes-list {
      list-style: none;
      padding: 0;
      
      li {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 12px;
        font-size: 0.95rem;
        
        .check-icon,
        .trophy-icon {
          color: #4CAF50;
          flex-shrink: 0;
        }
      }
    }
  }

  .curriculum-content {
    .curriculum-header {
      text-align: center;
      margin-bottom: 25px;
      
      h3 {
        margin: 0 0 5px 0;
        color: #333;
      }
      
      p {
        margin: 0;
        color: #666;
      }
    }
    
    .week-card {
      background: #f8f9fa;
      border: 1px solid #e0e0e0;
      border-radius: 12px;
      margin-bottom: 20px;
      padding: 20px;
    }
    
    .week-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      
      .week-info {
        h4 {
          margin: 0 0 5px 0;
          color: #333;
          font-size: 1.1rem;
        }
        
        .duration {
          font-size: 0.8rem;
          color: #666;
        }
      }
      
      .status {
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 0.8rem;
        
        &.completed {
          background: #e8f5e8;
          color: #4CAF50;
        }
        
        &.pending {
          background: #f5f5f5;
          color: #9E9E9E;
        }
      }
    }
    
    .topics-list {
      .topic-item {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;
        
        .topic-bullet {
          color: #4CAF50;
        }
      }
    }
  }

  .skills-content {
    .skills-header {
      text-align: center;
      margin-bottom: 25px;
      
      h3 {
        margin: 0 0 5px 0;
        color: #333;
      }
      
      p {
        margin: 0;
        color: #666;
      }
    }
    
    .skills-list {
      .skill-item {
        display: grid;
        grid-template-columns: 1fr 2fr auto;
        gap: 20px;
        align-items: center;
        padding: 20px 0;
        border-bottom: 1px solid #e0e0e0;
        
        .skill-info {
          .skill-name {
            font-weight: 600;
            color: #333;
            display: block;
            margin-bottom: 5px;
          }
          
          .skill-levels {
            display: flex;
            gap: 15px;
            font-size: 0.8rem;
            color: #666;
          }
        }
        
        .skill-progress {
          .progress-bg {
            position: relative;
            height: 8px;
            background: #f0f0f0;
            border-radius: 4px;
            overflow: hidden;

            .current-progress {
              height: 100%;
              border-radius: 4px;
              transition: width 0.3s ease;
            }

            .required-line {
              position: absolute;
              top: 0;
              bottom: 0;
              width: 2px;
              background: #007bff;
              transform: translateX(-1px);
            }
          }
        }
        
        .skill-status {
          font-size: 0.8rem;
          
          .status-good {
            color: #4CAF50;
          }
          
          .status-warning {
            color: #FF9800;
          }
          
          .status-poor {
            color: #F44336;
          }
        }
      }
    }
  }

  .reviews-content {
    .reviews-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 25px;
      
      h3 {
        margin: 0;
        color: #333;
      }
      
      .rating-summary {
        display: flex;
        align-items: center;
        gap: 10px;
        
        .rating-score {
          font-size: 1.5rem;
          font-weight: bold;
          color: #007bff;
        }
        
        .rating-stars {
          display: flex;
          gap: 2px;
          
          .filled {
            color: #FFD700;
          }
        }
        
        .rating-count {
          color: #666;
          font-size: 0.9rem;
        }
      }
    }
    
    .reviews-list {
      .review-item {
        background: #f8f9fa;
        border: 1px solid #e0e0e0;
        border-radius: 12px;
        margin-bottom: 20px;
        padding: 20px;
      }
      
      .review-header {
        display: flex;
        gap: 15px;
        margin-bottom: 15px;
        
        .reviewer-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
        
        .review-meta {
          .user-name {
            font-weight: 600;
            color: #333;
            margin-bottom: 5px;
          }
          
          .review-info {
            display: flex;
            align-items: center;
            gap: 15px;

            .rating {
              display: flex;
              gap: 2px;
              
              .filled {
                color: #FFD700;
              }
            }

            .date {
              font-size: 0.8rem;
              color: #666;
            }
          }
        }
      }
      
      .review-content {
        margin-bottom: 15px;
        line-height: 1.5;
        color: #666;
      }
      
      .review-actions {
        .helpful {
          font-size: 0.8rem;
          color: #666;
        }
      }
    }
  }

  .similar-content {
    h3 {
      margin: 0 0 5px 0;
      color: #333;
    }
    
    p {
      margin: 0 0 25px 0;
      color: #666;
    }
    
    .similar-courses {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 20px;
    }
    
    .similar-course-card {
      background: #f8f9fa;
      border: 1px solid #e0e0e0;
      border-radius: 12px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      }
      
      img {
        width: 100%;
        height: 120px;
        object-fit: cover;
      }
      
      .similar-course-info {
        padding: 15px;
        
        h4 {
          margin: 0 0 5px 0;
          color: #333;
          font-size: 1rem;
          line-height: 1.3;
        }
        
        .similar-course-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.8rem;
          
          .rating {
            display: flex;
            align-items: center;
            gap: 3px;
            color: #FFD700;
          }

          .students {
            color: #666;
          }

          .price {
            font-weight: 600;
            color: #4CAF50;
          }
        }
      }
    }
  }
`;

export default PersonalizedRecommendationDetail;